<script setup lang="ts">
const props = defineProps<{
  images: string[];
  startIndex?: number;
}>();
const emit = defineEmits<{ (e: 'close'): void }>();

const { t } = useI18n();

const idx = ref(props.startIndex ?? 0);
watch(
  () => props.startIndex,
  (v) => {
    idx.value = v ?? 0;
  },
);
const current = computed(() => props.images[idx.value] ?? '');
const hasMany = computed(() => props.images.length > 1);
const prev = () => {
  idx.value = (idx.value - 1 + props.images.length) % props.images.length;
};
const next = () => {
  idx.value = (idx.value + 1) % props.images.length;
};
</script>

<template>
  <Teleport to="body">
    <div
      class="pil"
      @click="emit('close')"
    >
      <img
        :src="current"
        alt=""
        @click.stop
      />
      <button
        v-if="hasMany"
        type="button"
        class="pil-nav prev"
        :aria-label="t('property.imageLightbox.previous')"
        @click.stop="prev"
      >
        <span
          class="inline-block rtl:-scale-x-100"
          aria-hidden="true"
          >‹</span
        >
      </button>
      <button
        v-if="hasMany"
        type="button"
        class="pil-nav next"
        :aria-label="t('property.imageLightbox.next')"
        @click.stop="next"
      >
        <span
          class="inline-block rtl:-scale-x-100"
          aria-hidden="true"
          >›</span
        >
      </button>
      <button
        type="button"
        class="pil-close"
        :aria-label="t('common.actions.close')"
        @click="emit('close')"
      >
        ✕
      </button>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.pil {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.85);
  padding: 24px;

  img {
    max-width: min(92vw, 1100px);
    max-height: 90vh;
    object-fit: contain;
    border-radius: 8px;
  }
}
.pil-close {
  position: absolute;
  top: 18px;
  inset-inline-end: 22px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.pil-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;

  &.prev {
    inset-inline-start: 18px;
  }
  &.next {
    inset-inline-end: 18px;
  }
}
</style>
